import React, { ReactNode, useState, useMemo } from "react"
import ClassNames from "classnames"
import DatePicker from "react-datepicker"
import { get } from "lodash"
import dayjs from "dayjs"
import { checkIsBrowser } from "utils/util"

type SearchInputType = {
  value: string
  onChange: Function
  onKeyDown?: Function
  onFocus?: Function
  onBlur?: Function
  className?: string
  inputId?: string
}
export const SearchInput: React.FC<SearchInputType> = props => {
  const [isFocus, setFocus] = useState<boolean>()
  return (
    <div className={props.className}>
      <input
        id={props.inputId && props.inputId}
        value={props.value}
        className={ClassNames("search-input", {
          active: !!props.value,
        })}
        type="text"
        name=""
        placeholder=""
        onChange={e => props.onChange(e.target.value)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) =>
          props.onKeyDown && props.onKeyDown(e)
        }
        onFocus={() => {
          setFocus(true)
          !!props.onFocus && props.onFocus()
        }}
        onBlur={() => {
          setFocus(false)
          !!props.onBlur && props.onBlur()
        }}
      />
      <div className="floating-label">銘柄名・コード検索</div>
    </div>
  )
}

type DateRangeType = {
  value: [string, string]
  onChange: Function
  placeholder: [string, string]
  title?: string
  cls?: string
  dateRange?: [string, string]
  format: string
}

export const DateRange: React.FC<DateRangeType> = props => {
  const formatDate = (date: Date) => dayjs(date).format(props.format)
  return (
    <div
      className={ClassNames(
        "filter-control-item filter-control-term",
        props.cls
      )}
    >
      {props.title ? (
        <div className="label-filter-control">{props.title}</div>
      ) : null}
      <div className="text-field text-field-outlined">
        <DatePicker
          value={get(props.value, "0", null)}
          className="text-field-input"
          placeholderText={props.placeholder[0]}
          onChange={date => {
            props.onChange([formatDate(date), get(props.value, "1", null)])
          }}
          minDate={get(props.dateRange, "0", null)}
          maxDate={get(props.value, "1", null)}
        />
      </div>
      <div className="symbol-term">～</div>
      <div className="text-field text-field-outlined">
        <DatePicker
          value={get(props.value, "1", null)}
          className="text-field-input"
          placeholderText={props.placeholder[1]}
          onChange={date =>
            props.onChange([get(props.value, "0", null), formatDate(date)])
          }
          minDate={get(props.value, "0", null)}
          maxDate={get(props.dateRange, "1", null)}
        />
      </div>
    </div>
  )
}

type Props = {
  className?: string
  labelName?: string
}

export const Label = (props: Props) => (
  <div className={ClassNames(props.className)}>
    <label className="btn-segmented-item">
      <input
        type="radio"
        name={props.labelName}
        className="input-segmented-control"
        checked={true}
      />
      <span className="segmented-content ripple">
        <div className="material-ink animate" />
        一般
      </span>
    </label>
    <label className="btn-segmented-item">
      <input
        type="radio"
        name={props.labelName}
        className="input-segmented-control"
      />
      <span className="segmented-content ripple">
        <div className="material-ink animate" />
        一般
      </span>
    </label>
  </div>
)

//todoひとまず

type LabelList = {
  name?: string
  id: string | number
}

type LabelProps = {
  className?: string
  labelList: Array<LabelList>
  checked?: string | number
  onChange: Function
  children?: ReactNode
  disabled?: boolean
}

export const Labels = (props: LabelProps) => {
  const _style = useMemo(() => {
    if (checkIsBrowser() === "ie") {
      switch (props.labelList.length) {
        case 2:
          return "two-btn"
        case 3:
          return "three-btn"
        case 4:
          return "four-btn"
        case 5:
          return "five-btn"
        case 6:
          return "six-btn"
      }
    }
  }, [])
  return (
    <div className={ClassNames(_style, props.className)}>
      {props.labelList.map((row: LabelList, i: number) => (
        <label
          key={i}
          className={ClassNames("btn-segmented-item", {
            checked: props.checked === row.id,
            disabled: props.disabled,
          })}
        >
          <input
            type="radio"
            name={row.name}
            className={ClassNames("input-segmented-control", {
              checked: props.checked === row.id,
            })}
            onChange={() => props.onChange(row.id)}
            checked={props.checked ? props.checked === row.id : false}
            disabled={props.disabled || false}
          />
          <span className="segmented-content ripple">{row.name}</span>
        </label>
      ))}
    </div>
  )
}

export const CheckBox = (props: { checked: boolean; onChange: Function }) => {
  const { checked, onChange } = props
  return (
    <label className="checkbox-control only-check-box">
      <input
        type="checkbox"
        checked={checked}
        onChange={e => {
          onChange(e)
        }}
      />
      <span></span>
    </label>
  )
}
